import { useState, useEffect } from "react";
import client from "../api/client";

function ChakraCheckin({ value, onChange }) {
  const [chakras, setChakras] = useState([]);
  const [showTranspersonal, setShowTranspersonal] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    client.get("/chakras")
      .then(res => setChakras(res.data))
      .catch(err => console.error("Error fetching chakras:", err))
      .finally(() => setLoading(false));
  }, []);

  const checkins = value || [];

  const isChecked = (chakraId) => checkins.some(c => c.chakra_id === chakraId);

  const getState = (chakraId) => {
    const found = checkins.find(c => c.chakra_id === chakraId);
    return found ? found.state : "";
  };

  const handleCheck = (chakra) => {
    if (isChecked(chakra.id)) {
      onChange(checkins.filter(c => c.chakra_id !== chakra.id));
    } else {
      onChange([...checkins, { chakra_id: chakra.id, name: chakra.name, state: "" }]);
    }
  };

  const handleStateChange = (chakraId, state) => {
    onChange(checkins.map(c =>
      c.chakra_id === chakraId ? { ...c, state } : c
    ));
  };

  const mainChakras = chakras.filter(c => !c.is_transpersonal);
  const transpersonalChakras = chakras.filter(c => c.is_transpersonal);

  const chakraStates = ["Open", "Blocked", "Overactive", "Underactive", "Healing", "Activated"];

  const renderChakra = (chakra) => (
  <div
    key={chakra.id}
    style={{
      display: "grid",
      gridTemplateColumns: "24px minmax(100px, 160px) auto",
      columnGap: "12px",
      alignItems: "center",
      padding: "8px 0",
      borderBottom: "1px solid rgba(255,255,255,0.05)",
    }}
  >
    <div style={{ width: "24px", display: "flex", justifyContent: "center" }}>
      <input
        type="checkbox"
        checked={isChecked(chakra.id)}
        onChange={() => handleCheck(chakra)}
        style={{ cursor: "pointer", width: "16px", height: "16px" }}
      />
    </div>

    <div style={{ minWidth: 0 }}>
      <span style={{ fontSize: "14px", fontWeight: "500" }}>
        {chakra.name}
      </span>
      {chakra.sanskrit_name && (
        <span style={{ fontSize: "11px", opacity: 0.5, marginLeft: "8px" }}>
          {chakra.sanskrit_name}
        </span>
      )}
    </div>

    <div style={{ justifySelf: "start", minWidth: "150px" }}>
      {isChecked(chakra.id) && (
        <select
          value={getState(chakra.id)}
          onChange={(e) => handleStateChange(chakra.id, e.target.value)}
          style={{
            fontSize: "13px",
            width: "150px",
            display: "block",
          }}
        >
          <option value="">-- Select state --</option>
          {chakraStates.map((s) => (
            <option key={s} value={s}>
              {s}
            </option>
          ))}
        </select>
      )}
    </div>
  </div>
);

  if (loading) return <p style={{ fontSize: "13px", opacity: 0.6 }}>Loading chakras...</p>;

  return (
    <div className="ChakraCheckin">
      <div style={{ marginBottom: "8px" }}>
        {mainChakras.map(renderChakra)}
      </div>

      <div
        onClick={() => setShowTranspersonal(!showTranspersonal)}
        style={{
          fontSize: "12px",
          opacity: 0.6,
          cursor: "pointer",
          marginTop: "12px",
          display: "flex",
          alignItems: "center",
          gap: "6px"
        }}
      >
        {showTranspersonal ? "▼" : "▶"} Higher chakras
      </div>

      {showTranspersonal && (
        <div style={{ marginTop: "8px" }}>
          {transpersonalChakras.map(renderChakra)}
        </div>
      )}
    </div>
  );
}

export default ChakraCheckin;